import { Controller } from "@hotwired/stimulus"
import { TurboBeforeFetchRequestEvent, TurboSubmitStartEvent } from "@hotwired/turbo"
import Confirmation from "../../confirmation"
import SelectionToolbarController from "../selection_toolbar_controller"
import type SearchFormController from "../search_form_controller"

export default class ListController extends Controller {
  static outlets = ["search-form"]
  static values = { "deleteTerm": String }
  static targets = [
    "deleteSelectedBtn",
    "toolbar",
  ]

  declare searchFormOutlet: SearchFormController
  declare hasSearchFormOutlet: boolean
  declare deleteSelectedBtnTarget: HTMLButtonElement
  declare deleteTermValue: string
  declare toolbarTarget: HTMLDivElement

  deleteSelectedBtnTargetConnected(el: HTMLButtonElement) {
    const form = el.closest("form")
    if (!form) {
      return
    }

    form.addEventListener("turbo:before-fetch-request", async (event: TurboBeforeFetchRequestEvent) => {
      event?.preventDefault()

      // Use warning for archive (reversible), danger for delete (permanent)
      const type = this.deleteTermValue === "archive" ? "warning" : "danger"

      if (await Confirmation.confirm({
        text: `Are you sure you want to ${this.deleteTermValue} the selected messages?`,
        confirmButtonText: `Yes, ${this.deleteTermValue}!`,
        type
      })) {
        event.detail.resume(null)
      } else {
        const selectionToolbar = SelectionToolbarController.getInstance(this.toolbarTarget)
        selectionToolbar?.clearSelected()
      }
    })

    form.addEventListener("turbo:submit-start", (event: TurboSubmitStartEvent) => {
      const selectionToolbar = SelectionToolbarController.getInstance(this.toolbarTarget)
      const ids = selectionToolbar?.selectedIds() || []
      ids.forEach(id => {
        event.detail.formSubmission.fetchRequest.body
          .append("ids[]", id)
      })
    })
  }

  async confirmDelete(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    // Use warning for archive (reversible), danger for delete (permanent)
    const type = this.deleteTermValue === "archive" ? "warning" : "danger"

    if (await Confirmation.confirm({
      text: `Are you sure you want to ${this.deleteTermValue} this message?`,
      confirmButtonText: `Yes, ${this.deleteTermValue}!`,
      type
    })) {
      event.detail.resume(null)
    }
  }

  appendSearchParams(event: TurboSubmitStartEvent) {
    if (!this.hasSearchFormOutlet) return

    const formData = new FormData(this.searchFormOutlet.formTarget)
    formData.forEach((value, key) => {
      if (typeof value === "string") {
        event.detail.formSubmission.fetchRequest.body.append(key, value)
      }
    })
  }

  getSelectionToolbarController(): SelectionToolbarController | null {
    return SelectionToolbarController.getInstance(this.toolbarTarget)
  }
}
